<template>
<div class="SpecialEdit padding-20 bgc box-shadow">
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="120px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="内容标题" prop="subject">
                <el-input v-model.trim="item.subject" placeholder="请输入标题" maxlength="100" show-word-limit clearable :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item label="所属板块" required>
                <el-select v-model="item.newstypekind" placeholder="所属板块" class="condition" :disabled="isView">
                    <el-option v-for="obj in newstypekindList" :key="obj.code" :label="obj.name"
                               :value="obj.code" v-if="obj.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属科目">
                <el-select v-model="item.subjectcode" placeholder="请选择分类" class="condition" clearable :disabled="isView">
                    <el-option v-for="obj in subjectcodeList" :key="obj.code" :label="obj.name"
                               :value="obj.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="作者名称">
                <el-input v-model.trim="item.authorname" placeholder="请输入作者名称" maxlength="50" show-word-limit clearable :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item label="内容标签">
                <el-input v-model.trim="item.tagsname" placeholder="请输入内容标签" maxlength="50" show-word-limit clearable :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item label="是否推荐">
                <el-radio-group v-model="item.isrecommend" :disabled="isView">
                    <el-radio :label="1">推荐</el-radio>
                    <el-radio :label="0">不推荐</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="发布日期" prop="releasetime">
                <el-date-picker v-model="item.releasetime" type="date" placeholder="请选择发布日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="isView" :picker-options="pickerDateFront"></el-date-picker>
            </el-form-item>
            <el-form-item label="内容关键字">
                <el-input v-model.trim="item.keyname" placeholder="请输入内容关键字" maxlength="50" show-word-limit clearable :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item label="链接类型" required>
                <el-radio-group v-model="item.urltype" :disabled="isView">
                    <el-radio :label="1">自有内容</el-radio>
                    <el-radio :label="2">第三方内容</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="内容正文" v-show="item.urltype==1">
                <uEditor v-if="!isView" :content="item.content" ref="uEditor" @getUEditorContent="getUEditorContent" placeholder="请输入内容正文"></uEditor>
                <div v-else v-html="item.content"></div>
            </el-form-item>
            <el-form-item label="链接Url" v-show="item.urltype==2" :prop="item.urltype==2 ?'linkurl':''">
                <el-input v-model.trim="item.linkurl" placeholder="请输入链接Url" maxlength="200" show-word-limit clearable :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item class="btnBox">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submit" v-if="!isView">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>
import {special} from 'api/enumCode'
import UEditor from 'base/uEditor/uEditor2'
import {mapGetters, mapActions} from 'vuex'
import {uploadQuestionbanktopiccontent, getQuestionbanktopiccontentDetail} from 'api/questionApi'
export default {
    name: 'SpecialEdit',
    data() {
        return {
            newstypekindList: special.newstypekind,
            subjectcodeList: special.subjectcode,
            param: {
                examcode: this.$route.query.examcode ? this.$route.query.examcode : '',
                innerid: this.$route.query.innerid ? this.$route.query.innerid : ''
            },
            item: {
                authorname: '', // 作者名称
                content: '', // 资讯内容
                examcode: this.$route.query.examcode ? this.$route.query.examcode : '', // 专题题库code
                innerid: this.$route.query.innerid ? this.$route.query.innerid : '', // 内容ID 新增为空 ,
                isrecommend: 0, // 是否推荐 0否1是
                keyname: '', // 内容关键字
                linkurl: '', // 第三方链接url
                releasetime: '', // 发布日期
                subject: '', // 内容标题
                subjectname: '', // 所属科目名称
                tagsname: '', // 内容标签
                urltype: 1, // 1自有资讯 2第三方Url
                newstypekind: 1, // 所属板块 1报考指导 2历年真题 3备考指导 4易错题 5模拟试题
                subjectcode: '' // 所属科目code
            },
            rules: {
                subject: [
                    {required: true, message: '请输入标题', trigger: 'blur'}
                ],
                releasetime: [
                    {required: true, message: '请选择发布日期', trigger: 'blur'}
                ],
                linkurl: [
                    {required: true, message: '请输入链接Url', trigger: 'blur'}
                ]
            },
            pickerDateFront: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                }
            },
            isView: this.$route.query.isView ? true : false,
            isCopy: this.$route.query.isCopy ? true : false
        }
    },
    mounted() {
        if (this.param.innerid) {
            this._getView()
        } else {
            let currentDate = new Date()
            this.item.releasetime = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getDate()
        }
    },
    methods: {
        getUEditorContent(content) {
            this.item.content = content
        },
        cancel() {
            this.$router.back()
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认保存？', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save()
                    })
                }
            })
        },
        _save() {
            this.setLoading(true)
            uploadQuestionbanktopiccontent({
                data: Object.assign({}, this.item),
                success: () => {
                    this.setLoading(false)
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getQuestionbanktopiccontentDetail({
                data: Object.assign({}, this.param),
                success: data => {
                    data.data.examcode = this.param.examcode
                    this.item = data.data
                    if (this.isCopy) {
                        this.item.innerid = ''
                        let currentDate = new Date()
                        this.item.releasetime = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getDate()
                    }
                    if (this.item.urltype == 1) {
                        this.$nextTick(() => {
                            this.$refs.uEditor.init(this.item.content)
                        })
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UEditor
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.SpecialEdit {
    .form{
        margin: 0;
        width: 800px;
    }
}
</style>
